import React, { Component } from 'react';
import { getChildren } from '@/utils/constant';


const getConfig = (props) => {
  const { imgUrl, title, subTitle, cid, vid, titleColor = 'inherit', subTitleColor = 'inherit', background = 'inherit', size = 'default-vt', style = {} } = props || {};
  const conSize = size === 'small' ? '33.3%' : '50%';
  const config = [
    {
      name: "Container",
      props: {
        size: 'half',
        style: {
          width: conSize,
          marginBottom: '8px',
          background
        }
      },
      children: [
        {
          name: "Container",
          props: {
            style: {
              width: '96%',
              flexDirection: 'column'
            }
          },
          children:[
            {
              name: "Image",
              props: {
                src: imgUrl,
                size: size,
                cid,
                vid,
                event: 'openView',
                style: {
                  ...style
                }
              },
            },
            {
              name: "Text",
              props: {
                size: 'big',
                text: title,
                style: { color: titleColor },
              }
            },
            {
              name: "Text",
              props: {
                size: 'small',
                text: subTitle,
                style: { color: subTitleColor },
              }
            },
          ]
        }

      ],
    }
  ];

  return config;
}


export class Movie extends Component {

  render() {
    const config = getConfig(this.props)

    return (
      <>{getChildren(config)}</>
    );
  }
}

export default Movie;
